import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'iconLabel' })
export class IconLabelPipe implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: string): any {
    return this.translateService.instant(`ICON_LABEL.${value.toUpperCase()}`);
  }
}
